// Renders a US number in (XXX) XXX-XXXX form, leaving anything non-standard
// (short codes, international) as-is.
export function formatPhoneNumber(raw: string | null | undefined): string {
    if (!raw) {
        return '—';
    }
    const digits = raw.replace(/\D/g, '');
    const local =
        digits.length === 11 && digits.startsWith('1')
            ? digits.slice(1)
            : digits;
    if (local.length === 10) {
        return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
    }
    return raw;
}
